export default window.__litium.constants;

export const ViewMode = {
  List: 'list',
  Edit: 'edit',
  Detail: 'detail',
};

export const PaginationOptions = {
  PageSize: 5, // Number of items per page
  DisplayedEntries: 4, // Specifies how many links to show excluding possible EdgeEntries
  EdgeEntries: 2, // Specifies how many links from beginning and end to show ex. 1 2 3 ... 10 20 30 ... 97 98 99 where "1 2 3" and "97 98 99" are edge entries
};

export const ShippingIntegrationType = {
  Inline: 'Inline',
  DeliveryCheckout: 'DeliveryCheckout',
  PaymentCheckout: 'PaymentCheckout',
};

export const PaymentIntegrationType = {
  IframeCheckout: 'IframeCheckout',
  PaymentWidgets: 'PaymentWidgets',
  DirectPayment: 'DirectPayment',
};

export const AddressType = {
  POD: 'POD',
};

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';

export const CLERK_QUICK_SEARCH_QUERY = 'CLERK_QUICK_SEARCH_QUERY';
export const CLERK_QUICK_SEARCH_RECEIVE = 'CLERK_QUICK_SEARCH_RECEIVE';
export const CLERK_QUICK_SEARCH_RECEIVE_SUGGESTIONS =
  'CLERK_QUICK_SEARCH_RECEIVE_SUGGESTIONS';
export const CLERK_QUICK_SEARCH_RECEIVE_CATEGORIES =
  'CLERK_QUICK_SEARCH_RECEIVE_CATEGORIES';
export const CLERK_QUICK_SEARCH_ERROR = 'CLERK_QUICK_SEARCH_ERROR';
export const CLERK_QUICK_SEARCH_SHOW_FULL_FORM =
  'CLERK_QUICK_SEARCH_SHOW_FULL_FORM';
export const CLERK_QUICK_SEARCH_SELECT_ITEM = 'CLERK_QUICK_SEARCH_SELECT_ITEM';

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_INFO = 'CART_SHOW_INFO';
export const CART_SHOW_MINI_CART = 'CART_SHOW_MINI_CART';
export const CART_UPDATE_ADDITIONAL_INFO = 'CART_UPDATE_ADDITIONAL_INFO';

export const CHECKOUT_SET_SELECTED_COMPANY_ADDRESS =
  'CHECKOUT_SET_SELECTED_COMPANY_ADDRESS';
export const CHECKOUT_SET_PRIVATE_CUSTOMER = 'CHECKOUT_SET_PRIVATE_CUSTOMER';
export const CHECKOUT_SET_SIGN_UP = 'CHECKOUT_SET_SIGN_UP';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_USED_DISCOUNT_CODE =
  'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_SET_ORDER_NOTE = 'CHECKOUT_SET_ORDER_NOTE';
export const CHECKOUT_ACCEPT_TERMS_OF_CONDITION =
  'CHECKOUT_ACCEPT_TERMS_OF_CONDITION';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SUBMIT_BUTTON_STATE = 'CHECKOUT_SUBMIT_BUTTON_STATE';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_UPDATE_CUSTOMER_INFO = 'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS =
  'CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS';
export const CHECKOUT_SET_STATUS_SUBMIT_BUTTON =
  'CHECKOUT_SET_STATUS_SUBMIT_BUTTON';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CHECKOUT_VALIDATE_ADDRESS = 'CHECKOUT_VALIDATE_ADDRESS';
export const CHECKOUT_SET_DELIVERY_CONDITIONS =
  'CHECKOUT_SET_DELIVERY_CONDITIONS';
export const CHECKOUT_UPDATE_ADDITIONAL_INFO =
  'CHECKOUT_UPDATE_ADDITIONAL_INFO';

export const FACETED_SEARCH_QUERY = 'FACETED_SEARCH_QUERY';
export const FACETED_SEARCH_RECEIVE = 'FACETED_SEARCH_RECEIVE';
export const FACETED_SEARCH_ERROR = 'FACETED_SEARCH_ERROR';
export const FACETED_SEARCH_TOGGLE_VALUE = 'FACETED_SEARCH_TOGGLE_VALUE';
export const FACETED_SEARCH_TOGGLE_COMPACT = 'FACETED_SEARCH_TOGGLE_COMPACT';
export const PRODUCT_VIEW_CACHED = 'PRODUCT_VIEW_CACHED';

export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE =
  'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';
export const LIGHTBOX_IMAGES_SET_IMAGES = 'LIGHTBOX_IMAGES_SET_IMAGES';

export const LOGIN_SHOW_CHANGE_PASSWORD = 'LOGIN_SHOW_CHANGE_PASSWORD';
export const LOGIN_SHOW_SELECT_ORGANIZATION = 'LOGIN_SHOW_SELECT_ORGANIZATION';
export const LOGIN_SET_IS_LOADING = 'LOGIN_SET_IS_LOADING';
export const LOGIN_SET_ORGANIZATIONS = 'LOGIN_SET_ORGANIZATIONS';
export const LOGIN_SET_USERNAME_PASSWORD = 'LOGIN_SET_USERNAME_PASSWORD';
export const LOGIN_SET_MODAL_OPEN = 'LOGIN_SET_MODAL_OPEN';
export const LOGIN_SET_LOGIN_MODE = 'LOGIN_SET_LOGIN_MODE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SET_REDIRECT_URL = 'LOGIN_SET_REDIRECT_URL';
export const LOGIN_SET_MAGIC_LINK_MODEL = 'LOGIN_SET_MAGIC_LINK_MODEL';
export const LOGIN_SET_TERMS = 'LOGIN_SET_TERMS';

export const NAVIGATION_LOAD_ERROR = 'NAVIGATION_LOAD_ERROR';
export const NAVIGATION_RECEIVE = 'NAVIGATION_RECEIVE';

export const PERSON_RECEIVE = 'PERSON_RECEIVE';
export const PERSON_ERROR = 'PERSON_ERROR';
export const PERSON_CHANGE_MODE = 'PERSON_CHANGE_MODE';

export const PRODUCT_LISTING_SET_PROP = 'PRODUCT_LISTING_SET_PROP';
export const PRODUCT_LISTING_RECEIVE = 'PRODUCT_LISTING_RECEIVE';

export const PRODUCT_FILTERING_RECEIVE = 'PRODUCT_FILTERING_RECEIVE';

export const QUICK_SEARCH_QUERY = 'QUICK_SEARCH_QUERY';
export const QUICK_SEARCH_RECEIVE = 'QUICK_SEARCH_RECEIVE';
export const QUICK_SEARCH_ERROR = 'QUICK_SEARCH_ERROR';
export const QUICK_SEARCH_SHOW_FULL_FORM = 'QUICK_SEARCH_SHOW_FULL_FORM';
export const QUICK_SEARCH_SELECT_ITEM = 'QUICK_SEARCH_SELECT_ITEM';

export const QUICK_ORDER_ADD = 'QUICK_ORDER_ADD';
export const QUICK_ORDER_REMOVE = 'QUICK_ORDER_REMOVE';
export const QUICK_ORDER_UPDATE = 'QUICK_ORDER_UPDATE';
export const QUICK_ORDER_NEW_ROW_ACTIVE = 'QUICK_ORDER_NEW_ROW_ACTIVE';
export const QUICK_ORDER_SET_NEW_ROW_VALUE = 'QUICK_ORDER_SET_NEW_ROW_VALUE';
export const QUICK_ORDER_CHANGE_QUANTITY = 'QUICK_ORDER_CHANGE_QUANTITY';
export const QUICK_ORDER_LOAD_ERROR = 'QUICK_ORDER_LOAD_ERROR';

export const ORDER_RECEIVE = 'ORDER_RECEIVE';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_CHANGE_MODE = 'ORDER_CHANGE_MODE';
export const ORDER_CHANGE_CURRENTPAGE = 'ORDER_CHANGE_CURRENTPAGE';
export const ORDER_SET_ORDER = 'ORDER_SET_ORDER';

export const OVERLAY_ADD_OVERLAY = 'OVERLAY_ADD_OVERLAY';
export const OVERLAY_CLOSE_OVERLAY = 'OVERLAY_CLOSE_OVERLAY';
export const OVERLAY_REMOVE_OVERLAY = 'OVERLAY_REMOVE_OVERLAY';
export const OVERLAY_UPDATE_OVERLAY = 'OVERLAY_UPDATE_OVERLAY';

export const REGISTER_FORM_RECEIVE = 'REGISTER_FORM_RECEIVE';

export const breakpointValues = {
  xsmall: 0,
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1440,
  xxlarge: 1920,
};

// Must be in correct order from smallest first to largest last
export const breakpoints = {
  xsmall: breakpointValues.xsmall + 'px',
  small: breakpointValues.small + 'px',
  medium: breakpointValues.medium + 'px',
  large: breakpointValues.large + 'px',
  xlarge: breakpointValues.xlarge + 'px',
  xxlarge: breakpointValues.xxlarge + 'px',
};

export const breakpointClasses = [
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
];

export const rowMaxWidth = '1656px';

export const gridRowGutter = {
  xsmall: '1.6rem',
  large: '2.4rem',
};

export const gridRowPadding = {
  xsmall: '1.6rem',
  medium: '2.4rem',
  large: '3.2rem',
  xlarge: '4.8rem',
};

export const ButtonStates = {
  Default: 'default',
  Loading: 'loading',
  Success: 'success',
  Empty: '',
  Error: 'error',
};

export const LoginModes = {
  Login: 'Login',
  Terms: 'Terms',
  ChangePassword: 'ChangePassword',
  ForgotPassword: 'ForgotPassword',
  SelectOrganization: 'SelectOrganization',
};

export const ProductListingType = {
  List: 'List',
  Grid: 'Grid',
};

export const hookBreakpointVariables = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1440px',
  '3xl': '1920px',
};

export const SellerBoxSizes = {
  small: 'small',
  large: 'large',
};

export const InfoBoxPlacements = {
  Top: 'top',
  TopStart: 'top-start',
  TopEnd: 'top-end',
  Bottom: 'bottom',
};

export const MyPagesComponentConstants = {
  WebshopOrders: 'WebshopOrders',
};
